// extracted by mini-css-extract-plugin
export default {"container":"dataTable_container__5+vtJ","button_wrap":"dataTable_button_wrap__BpETZ"};